import queryString from 'query-string';
import type { NskResponse } from '~/models/Api';
import { deleteRequest, postRequest } from '~/utils/api/api_handler';
import type {
  DealConstruction,
  DealConstructionEdit
} from '~/models/DealConstruction';
import { generatePath } from '~/utils/generatePath';
import { convertDealConstructionToPayload } from '~/utils/api/convertDealConstructionPayload';

export const create = async (
  dealEstimationHistory: DealConstructionEdit,
  dealId: number,
  dealEstimationId: number | null,
  id: number | null
): Promise<NskResponse<void>> =>
  postRequest(
    queryString.stringifyUrl({
      url: generatePath('/vendors/deals/:deal_id/deal_estimation_histories', {
        deal_id: dealId
      }),
      query: { deal_estimation_id: dealEstimationId, id, version: 'v2' }
    }),
    {
      dealEstimationHistory: convertDealConstructionToPayload(
        dealEstimationHistory
      )
    }
  );

export const updateTypeDelete = async (
  dealId: number,
  dealEstimationId: number
): Promise<NskResponse<void>> =>
  postRequest(
    queryString.stringifyUrl({
      url: generatePath('/vendors/deals/:deal_id/deal_estimation_histories', {
        deal_id: dealId
      }),
      query: { deal_estimation_id: dealEstimationId, version: 'v2' }
    }),
    {
      dealEstimationHistory: {
        operationType: 'delete'
      }
    }
  );

export const destroy = async (
  dealId: number,
  dealEstimationHistoryId: number
): Promise<NskResponse<void>> =>
  deleteRequest(
    generatePath('/vendors/deals/:deal_id/deal_estimation_histories/:id', {
      deal_id: dealId,
      id: dealEstimationHistoryId
    })
  );

export const updateSeq = async (
  dealEstimationHistories: DealConstruction[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(
    generatePath(
      '/vendors/deals/:deal_id/deal_estimation_histories/update_seq',
      {
        deal_id: dealId
      }
    ),
    {
      dealEstimationHistories
    }
  );
